<div class="semi-interpenetrating-network-disclosure-container">
    <div class="semi-interpenetrating-network-disclosure-item-container">
        <div class="semi-interpenetrating-network-disclosure-item-input-container">
            <mat-form-field appearance="outline" class="semi-interpenetrating-network-disclosure-form-field">
                <mat-label>Please disclose whether a semi-interpenetrating network is formed</mat-label>
                <input matInput #semiInterpenetratingNetworkDisclosureInput [(ngModel)]="semiInterpenetratingNetworkDisclosure"
                    class="semi-interpenetrating-network-disclosure semi-interpenetrating-network-disclosure-item-input"
                    (keyup.enter)="updateSemiInterpenetratingNetworkDisclosure($event)" (keyup.escape)="cancelUpdate()"
                    (blur)="updateSemiInterpenetratingNetworkDisclosure($event)" />
                <mat-icon matSuffix (mousedown)="clearSemiInterpenetratingNetworkDisclosureInputField()">cancel</mat-icon>
            </mat-form-field>
        </div>
    </div>
</div>